// extracted by mini-css-extract-plugin
export var errorsContainer = "_t0-1";
export var link = "_t0-0";